import React from 'react'
import { AgChartsReact } from 'ag-charts-react';

const UsersChart = ({ data }) => {
  const chartData = {
    data: data,
    series: [{ type: 'bar', xKey: 'month', yKey: 'users' }],
  }

  return (
    <AgChartsReact options={chartData} />
  );
}

export default UsersChart